import { DrawnUserJackpotDto } from '../../../app';

export const greatWinSlugs = ['Final1', 'Platinum', 'Partner', 'ActivePlayers'] as const;

export type TGreatWinSlug = (typeof greatWinSlugs)[number];

export type TLeaguesSlug = Exclude<DrawnUserJackpotDto['slug'], TGreatWinSlug>;

export type TGreatWinSlugWithWinAmount = {
  slug: TGreatWinSlug;
  amount: string;
};

export type TLeaguesSlugWithWinAmount = {
  slug: TLeaguesSlug;
  amount: string;
};
